import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import Box from "@mui/material/Box";
import { NavigationVertical } from "../../components/NavigationBar/vertical";
import { MobileViewNavBar } from "../../components/NavigationBar/MobileViewNavBar";
import { useAuth } from "../../hooks/useAuth";

const drawerWidth = 300;

const hDrawerWidth = 0;
const DashboardLayout = (props) => {
  const { user, isAuthenticated, getUserDetailsNotAsync, getUserDetails, setUserDetailsNotAsync } = useAuth();
  const { children, tab, publicPage, application } = props;
  const isDesktop = useMediaQuery({ minWidth: 665 });
  const [mobileOpen, setMobileOpen] = React.useState(false);
  let userData = getUserDetailsNotAsync();

  // Add Variables

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box
      className="dashboard"
      sx={{
        display: "flex",
        backgroundColor: "#f1f2f3",
        height: "100vh",
        overflow: "auto"
      }}
    >
      <Box
        component="nav"
        sx={{
          width: { sm: drawerWidth },
          flexShrink: { sm: 0 },
          backgroundColor: "#8a8a8a",
        }}
      >
        {isDesktop ? null : (
          <><MobileViewNavBar PaperProps={{ style: { width: "100%" } }} onDrawerToggle={handleDrawerToggle}/>
          <NavigationVertical
            PaperProps={{ style: { width: drawerWidth } }}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            userData={userData}
          /></>
          
        )}

        <NavigationVertical
          PaperProps={{ style: { width: drawerWidth } }}
          sx={{ display: { sm: "block", xs: "none" } }}
          userData={userData}
        />
      </Box>

      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
         
        }}
      >
        <Box
          component="main"
          sx={{
            flex: 1,
            minWidth: "80%",
            mt:  isDesktop ? 0 : 10,
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export { DashboardLayout };
